import ColumnTag from './ColumnTag';

export {
  ColumnTag,
};



// WEBPACK FOOTER //
// ./src/components/ui/DragSources/index.js